import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Redirect, RouteComponentProps, withRouter } from "react-router";
import "./Navbar.scss";
import { ArrowBack, ExpandMore, Edit } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { Parts } from "../Write";
import ReactGA from "react-ga";

type Props = {
    menu: number;
    setMenu: (arg: number) => void;
    title: string;
    published?: boolean;
    parts: Parts[];
    handleSave: () => Promise<void>;
    handlePublish: () => Promise<void>;
    selectedIndex: number;
    setSelectedIndex: (val: number) => void;
    addNewStory: () => void;
    storyId: string;
};

const Navbar: React.FC<Props & RouteComponentProps> = (props) => {
    const [loggedIn, setLoggedIn] = useState<boolean>(true);
    window.onclick = function (event: any) {
        console.log(!event.target.matches(".check__container"));
        if (
            !event.target.matches(".dropbtn") &&
            !event.target.matches(".dropdown-content") &&
            !event.target.matches(".filter__check") &&
            !event.target.matches(".check__container") &&
            !event.target.matches(".checkmark")
        ) {
            var dropdowns = document.getElementsByClassName("dropdown-content");
            var i;
            for (i = 0; i < dropdowns.length; i++) {
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains("show")) {
                    openDropdown.classList.remove("show");
                }
            }
        }
    };
    useEffect(() => {
        if (Cookies.get("token") === undefined) {
            setLoggedIn(false);
        }
    }, []);
    function handleDrop(e: any) {
        document.getElementById(e.target.name)?.classList.toggle("show");
    }
    return loggedIn ? (
        // return (
        <div className="navbar">
            <div className="navbar__left">
                <button
                    className="icon_button"
                    onClick={() => props.history.goBack()}
                >
                    <ArrowBack style={{ pointerEvents: "none" }} />
                </button>
                <div className="navbar__links">
                    <button
                        className={`navbar__button ${
                            props.menu == 0 ? "active" : ""
                        }`}
                        onClick={() => props.setMenu(0)}
                        disabled={props.storyId === ""}
                    >
                        Scrapbook
                    </button>
                    <button
                        className={`navbar__button ${
                            props.menu == 1 ? "active" : ""
                        }`}
                        onClick={() => props.setMenu(1)}
                    >
                        Settings
                    </button>
                </div>
            </div>
            <div className="navbar__right">
                <p className="title">{props.title}</p>
                <div className="dropdown">
                    <button
                        onClick={(e) => handleDrop(e)}
                        className="dropbtn write"
                        name="dwrite"
                    >
                        <span style={{ pointerEvents: "none" }}>
                            Part {props.selectedIndex + 1}:{" "}
                            {props.parts[props.selectedIndex].title}
                        </span>{" "}
                        <ExpandMore
                            style={{ pointerEvents: "none" }}
                            name="dwrite"
                        />
                    </button>
                    <div className="dropdown-wrapper pt_0" id="dwrite">
                        <div className="dropdown-content">
                            <ul>
                                {props.parts.map((part, index) => (
                                    <li
                                        onClick={() => {
                                            props.setSelectedIndex(index);
                                            document
                                                .getElementById("dwrite")
                                                ?.classList.remove("show");
                                        }}
                                    >
                                        Part {index + 1}: {part.title}
                                    </li>
                                ))}
                                <li
                                    className="write"
                                    onClick={() => {
                                        props.addNewStory();
                                        document
                                            .getElementById("dwrite")
                                            ?.classList.remove("show");
                                    }}
                                >
                                    Write a new part{" "}
                                    <Edit
                                        style={{
                                            height: "18px",
                                            width: "18px",
                                        }}
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="vertical_divider"></div>
                <button
                    className="secondary__btn"
                    onClick={() =>
                        props.handleSave().then(() =>
                            ReactGA.event({
                                category: "Write Story",
                                action: "Save story",
                            })
                        )
                    }
                >
                    <i className="fa fa-refresh fa-spin"></i>Save
                </button>
                <button
                    className="primary__btn"
                    style={{ marginLeft: "10px", marginBottom: "0" }}
                    onClick={() =>
                        props.handlePublish().then(() =>
                            ReactGA.event({
                                category: "Write Story",
                                action: "Publish story",
                            })
                        )
                    }
                    disabled={props.published}
                >
                    {!props.published ? "Publish" : "Published"}
                </button>
            </div>
        </div>
    ) : (
        <Redirect to="/login" />
    );
};

export default withRouter(Navbar);
